<main class="main-container">

    <!-- عنوان صفحه -->

    <div class="bg-th-yellow mt-0 container-fluid">

        <div class=" d-flex justify-content-between align-content-center h-35">
      
          <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>
      
          <span class="my-auto f16 fw-bold me-2"> پشتیبانی و شکایات  </span>
      
        </div>
      
    </div>

    <!-- جدول اطلاعات  -->
    
    <section class="w-100 row gx-0 gy-0 p-2" style="direction: rtl;">

        <div class="border border-2 mt-3 p-2">

            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result($event.target.value)">
    
            <div class="section border border-2 mt-2" style="height:calc(100vh - 130px);overflow: auto;">
    
                <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
                    <thead>
    
                        <tr class="">
    
                            <th class="text-center col-1"> # </th>
    
                            <th class="text-center"> کد </th>
    
                            <th class="text-center"> وضعیت </th>
    
                            <th class="text-center"> تاریخ </th>
    
                            <th class="text-center"> ساعت </th>
    
                            <th class="text-center"> موضوع </th>
    
                            <th class="text-center"> نام خانوادگی </th>

                            <th class="text-center"> موبایل </th>
    
                        </tr>
    
                    </thead>
    
                    <tbody>
    
                        <tr class="col-12 text-center" *ngFor="let item of lst_Ticket;let i = index" [ngClass]="{'bg-smoke': item.iTaxiLon_Tiket == 0,'bg-green-light': item.iTaxiLon_Tiket == 1,'bg-purpel': item.iTaxiLon_Tiket == 2,'bg-green-dark': item.iTaxiLon_Tiket == 3,'bg-pink': item.iTaxiLon_Tiket == 4,'bg-yellow': item.iTaxiLon_Tiket == 5,'bg-blue-light': item.iTaxiLon_Tiket == 6 }">
    
                            <th> {{ i + 1 | faNum }} </th>

                            <td> {{ item.iTaxiLon_Tiket | faNum }} </td>

                            <td> {{ item.strTiketStatus_strComment | faNum }} </td>

                            <td> {{ item.strSaveDate | faNum }} </td>

                            <td> {{ item.strSaveTime | faNum }} </td>

                            <td> {{ item.strTiketSubject_strComment | faNum }} </td>

                            <td> {{ item.strName + ' ' + item.strFamily | faNum }} </td>

                            <td> {{ item.strMobile | faNum }} </td>
        
                        </tr>
    
                    </tbody>
    
                </table>
    
            </div>
    
        </div>

    </section>

</main>